module.exports = __webpack_public_path__ + "img/lwfIcon.59186ccc.svg";